import React from "react";
import PropTypes from 'prop-types';
import { requestGIFCategories, searchGIFs, searchNextGIFs } from "actions/integrations";
import { connect } from "react-redux";
import { Scrollbar } from "react-scrollbars-custom";
import Loader from "ui/common/Loader";

class TenorGIFs extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			keyword: props.keyword,
			items: this.prepareItems(),
			tags: this.prepareTags()
		}

		this.handleChange = this.handleChange.bind(this);
		this.triggerOnChange = this.triggerOnChange.bind(this);
		this.handleClear = this.handleClear.bind(this);
		this.handleStopScroll = this.handleStopScroll.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.handleTagClick = this.handleTagClick.bind(this);
	}

	handleChange(event) {
		if (this.props.inProgress) {
			return;
		}

		if (this.actionsTrigger) {
			clearTimeout(this.actionsTrigger);
		}

		this.setState( state => ({ keyword: event.target.value }) );

		this.actionsTrigger = setTimeout(this.triggerOnChange, 600);
	}

	handleClear(e) {
		e.preventDefault();
		this.setState( state => ({ keyword: '' }) );
	}

	handleStopScroll(scrollValues, prevScrollValues) {
		if (this.state.keyword.length > 0 && this.props.next && scrollValues.scrollHeight - scrollValues.scrollTop - scrollValues.clientHeight < 10) {
			this.props.searchNextGIFs(this.state.keyword);
		}
	}

	triggerOnChange() {
		if (this.state.keyword.length > 0) {
			this.setState( state => ({ items: { col1: [], col2: []} }));
			this.props.searchGIFs(this.state.keyword);
		}
	}

	componentWillUnmount() {
		if (this.actionsTrigger) {
			clearTimeout(this.actionsTrigger);
		}
	}

	componentDidMount() {
		if (this.props.tags.length === 0) {
			this.props.requestGIFCategories();
		}
	}

	prepareItems() {
		return this.props.results.reduce((previous, gif) => {
			const height = gif.media_formats.tinygif.dims[1];

			const item = {
				id: gif.id,
				src: gif.media_formats.tinygif.url,
				description: gif.content_description
			};

			if (previous.col1height === 0) {
				return {
					...previous,
					col1height: height,
					col1: [item]
				};
			} else {
				if (previous.col1height < previous.col2height) {
					return {
						...previous,
						col1height: previous.col1height + height,
						col1: [...previous.col1, item]
					};
				} else {
					return {
						...previous,
						col2height: previous.col2height + height,
						col2: [...previous.col2, item]
					};
				}
			}
		}, {
			col1height: 0,
			col2height: 0,
			col1: [],
			col2: []
		});
	}

	prepareTags() {
		return {
			col1: this.props.tags.filter( (tag, index) => index % 2 === 0 ),
			col2: this.props.tags.filter( (tag, index) => index % 2 === 1 ),
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.results !== prevProps.results) {
			this.setState( state => ({ items: this.prepareItems() }) );
		}
		if (this.props.tags !== prevProps.tags) {
			this.setState( state => ({ tags: this.prepareTags() }) );
		}
	}

	handleClick(item) {
		const shortcode = `[img src="${ item.src }" className="wcTenorGIF"]`;

		this.props.onClick(shortcode);
	}

	handleTagClick(e, tag) {
		e.preventDefault();

		this.setState( state => ({ keyword: tag.searchterm }), this.triggerOnChange );
	}

	render() {
		return (
			<div className="wcTenor">
				<div className="wcTenorSearch">
					<input type="text" value={ this.state.keyword } className="wcControl" placeholder={ this.props.i18n.messageSearch } onChange={ this.handleChange } />
					{ this.state.keyword && <a href="#" className="wcClear wcFunctional" onClick={ this.handleClear } /> }
				</div>
				<Scrollbar onScrollStop={ this.handleStopScroll } noScrollX={ true } className="wcTenorResultsContainer">
					{ (this.state.keyword.length > 0 && this.props.results.length > 0) ? (
						<div className="wcTenorResults">
							<div className="wcTenorResultsColumn">
								{ this.state.items.col1.map( (item, index) => <img key={ index } onClick={ e => this.handleClick(item) } src={ item.src } alt={ item.description } className="wcFunctional" />) }
							</div>
							<div className="wcTenorResultsColumn">
								{ this.state.items.col2.map( (item, index) => <img key={ index } onClick={ e => this.handleClick(item) } src={ item.src } alt={ item.description } className="wcFunctional" />) }
							</div>
						</div>
					) : (
						<div className="wcTenorResults">
							<div className="wcTenorResultsColumn">
								{ this.state.tags.col1.map( (item, index) => <a href="#" key={ index } onClick={ e => this.handleTagClick(e, item) } className="wcFunctional"><img src={ item.image } className="wcFunctional" />{ item.name }</a>) }
							</div>
							<div className="wcTenorResultsColumn">
								{ this.state.tags.col2.map( (item, index) => <a href="#" key={ index } onClick={ e => this.handleTagClick(e, item) } className="wcFunctional"><img src={ item.image } className="wcFunctional" />{ item.name }</a>) }
							</div>
						</div>
					)}
					{ this.props.inProgress && <Loader message={ this.props.configuration.i18n.loading } center={ true } marginTop={ 10 } marginBottom={ 10 } /> }
				</Scrollbar>
				<div className="wcTenorPowered">Powered By Tenor</div>
			</div>
		)
	}

}


TenorGIFs.propTypes = {
	onClick: PropTypes.func.isRequired
};

export default connect(
	(state) => ({
		configuration: state.configuration,
		i18n: state.application.i18n,
		keyword: state.integrations.tenor.search.keyword,
		inProgress: state.integrations.tenor.search.inProgress || state.integrations.tenor.categories.inProgress,
		tags: state.integrations.tenor.categories.results,
		results: state.integrations.tenor.search.results,
		next: state.integrations.tenor.search.next
	}), { requestGIFCategories, searchGIFs, searchNextGIFs }
)(TenorGIFs);